import { render, staticRenderFns } from "./SubmitterChip.vue?vue&type=template&id=0ebeb35a&scoped=true&"
import script from "./SubmitterChip.vue?vue&type=script&lang=js&"
export * from "./SubmitterChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebeb35a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
